
export const NPI_ROLES_LANDING = 'NPI_ROLES_LANDING';
export const NPI_ROLES_LANDING_PENDING = 'NPI_ROLES_LANDING_PENDING';
export const NPI_ROLES_LANDING_FULFILLED = 'NPI_ROLES_LANDING_FULFILLED';
export const NPI_ROLES_LANDING_REJECTED = 'NPI_ROLES_LANDING_REJECTED';

export const NPI_ROLES_CREATE = 'NPI_ROLES_CREATE';
export const NPI_ROLES_CREATE_PENDING = 'NPI_ROLES_CREATE_PENDING';
export const NPI_ROLES_CREATE_FULFILLED = 'NPI_ROLES_CREATE_FULFILLED';
export const NPI_ROLES_CREATE_REJECTED = 'NPI_ROLES_CREATE_REJECTED';

export const NPI_ROLES_UPDATE = 'NPI_ROLES_UPDATE';
export const NPI_ROLES_UPDATE_PENDING = 'NPI_ROLES_UPDATE_PENDING';
export const NPI_ROLES_UPDATE_FULFILLED = 'NPI_ROLES_UPDATE_FULFILLED';
export const NPI_ROLES_UPDATE_REJECTED = 'NPI_ROLES_UPDATE_REJECTED';

export const NPI_ROLES_DELETE = 'NPI_ROLES_DELETE';
export const NPI_ROLES_DELETE_PENDING = 'NPI_ROLES_DELETE_PENDING';
export const NPI_ROLES_DELETE_FULFILLED = 'NPI_ROLES_DELETE_FULFILLED';
export const NPI_ROLES_DELETE_REJECTED = 'NPI_ROLES_DELETE_REJECTED';

export const NPI_ROLES_GET_BY_CONTRACT = 'NPI_ROLES_GET_BY_CONTRACT';
export const NPI_ROLES_GET_BY_CONTRACT_PENDING = 'NPI_ROLES_GET_BY_CONTRACT_PENDING';
export const NPI_ROLES_GET_BY_CONTRACT_FULFILLED = 'NPI_ROLES_GET_BY_CONTRACT_FULFILLED';
export const NPI_ROLES_GET_BY_CONTRACT_REJECTED = 'NPI_ROLES_GET_BY_CONTRACT_REJECTED';

export const NPI_ROLES_GET_BY_TARGET_CLIENT = 'NPI_ROLES_GET_BY_TARGET_CLIENT';
export const NPI_ROLES_GET_BY_TARGET_CLIENT_PENDING = 'NPI_ROLES_GET_BY_TARGET_CLIENT_PENDING';
export const NPI_ROLES_GET_BY_TARGET_CLIENT_FULFILLED = 'NPI_ROLES_GET_BY_TARGET_CLIENT_FULFILLED';
export const NPI_ROLES_GET_BY_TARGET_CLIENT_REJECTED = 'NPI_ROLES_GET_BY_TARGET_CLIENT_REJECTED';

export const NPI_ROLES_CREATE_UPDATE_RESET = 'NPI_ROLES_CREATE_UPDATE_RESET';

export const npiRolesLanding = () => ({
    type: NPI_ROLES_LANDING
});

export const createNPIRole = (values, callback, shouldReloadGrid) => ({
    type: NPI_ROLES_CREATE,
    payload: { values, callback, shouldReloadGrid }
});

export const updateNPIRole = (values, callback, shouldReloadGrid) => ({
    type: NPI_ROLES_UPDATE,
    payload: { values, callback, shouldReloadGrid }
});

export const deleteNPIRole = (npiRoleId, callback) => ({
    type: NPI_ROLES_DELETE,
    payload: { npiRoleId, callback }
});

export const createEditReset = () => ({
    type: NPI_ROLES_CREATE_UPDATE_RESET
});

export const getNPIRolesFromContract = (contractId) => ({
    type: NPI_ROLES_GET_BY_CONTRACT,
    payload: { contractId }
});

export const getNPIRolesFromTargetClient = (targetClient) => ({
    type: NPI_ROLES_GET_BY_TARGET_CLIENT,
    payload: { targetClient }
});

